import { render } from "./JobProjectManager.vue?vue&type=template&id=fbf56958&scoped=true"
import script from "./JobProjectManager.vue?vue&type=script&lang=js"
export * from "./JobProjectManager.vue?vue&type=script&lang=js"

import "./JobProjectManager.vue?vue&type=style&index=0&id=fbf56958&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbf56958"]])

export default __exports__